export default __webpack_public_path__ + "static/media/youtube.9817024e.svg";